import classNames from 'classnames';
import { sharedMarkdownComponents } from 'components/organisms/AIChat/utils'; // TODO: move to utils
import type { FC } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import type { ConversationMessageTextPart } from 'types/ai.types';

type AIMessagePartTextProps = {
  messageId: string;
  messagePart: ConversationMessageTextPart;
  isSmall?: boolean;
};

const AIMessagePartText: FC<AIMessagePartTextProps> = ({
  messageId,
  messagePart,
  isSmall,
}) => {
  return (
    <div className={classNames({ 'text-sm': isSmall })}>
      <ReactMarkdown
        key={messageId}
        remarkPlugins={[remarkGfm]}
        components={sharedMarkdownComponents}
      >
        {messagePart.content}
      </ReactMarkdown>
    </div>
  );
};

export default AIMessagePartText;
